// Search
const tools = document.querySelector('.tools');

let searchTool = tools.querySelector('.tools__search');
let searchPopup = document.querySelector('.search-popup');

searchTool.addEventListener('click', function(){
    document.body.classList.add('search-open');
    searchPopup.classList.remove('hideX');
    searchPopup.classList.add('showX');
    document.querySelector('.searchInput').focus()
})

if (searchPopup) {
    let searchClose = searchPopup.querySelector('.search-close');

    if (searchClose) {
        searchClose.addEventListener('click', function () {
            document.body.classList.remove('search-open');
            searchPopup.classList.add('hideX');
            searchPopup.classList.remove('showX');
        })
    }
}

// Function eventFire
function eventFire(el, etype){
    if (el.fireEvent) {
        el.fireEvent('on' + etype);
    } else {
        let evObj = document.createEvent('Events');
        evObj.initEvent(etype, true, false);
        el.dispatchEvent(evObj);
    }
}

// Google Translate
const translateBtn = tools.querySelector('.tools__translate');
!!translateBtn &&
    translateBtn.addEventListener('click', function(){
        let googleGadget = document.querySelector('#google_translate_element .skiptranslate .goog-te-gadget-simple');
        eventFire(googleGadget, 'click');
        return false;
    })

    
// Profils && Demarches 

const demarcheBtn = tools.querySelector('.tools__demarches');
const profileBtn = tools.querySelector('.tools__profile');

// Profils
!!profileBtn &&
profileBtn.addEventListener('click', function(){
    if(demarcheBtn.classList.contains("tool--open")) {
        demarcheBtn.classList.remove('tool--open');
      }
    profileBtn.classList.toggle('tool--open');
    profileBtn.closest('.header').querySelector('.tools-view .profils').classList.toggle('show-list');
})
document.addEventListener("click", (e) => {
    if (profileBtn.contains(e.target)) {
        console.log("inside");
    } 
    else {
        console.log("outside");
        document.querySelector('.tools-view .profils').classList.remove('show-list');
        profileBtn.classList.remove('tool--open');
    }
});

// Demarches
!!demarcheBtn &&
demarcheBtn.addEventListener('click', function(){
    if(profileBtn.classList.contains("tool--open")) {
        profileBtn.classList.remove('tool--open');
      }
    demarcheBtn.classList.toggle('tool--open');
    demarcheBtn.closest('.header').querySelector('.tools-view .demarches').classList.toggle('show-list');
})

document.addEventListener("click", (e) => {
    if (demarcheBtn.contains(e.target)) {
      console.log("inside");
    } 
    else {
      console.log("outside");
      document.querySelector('.tools-view .demarches').classList.remove('show-list');
      demarcheBtn.classList.remove('tool--open');   
    }
});


